import { useContext } from 'react';
import { StoreContext } from '../contexts';
import { RootStore } from '../models';

export const useStore = (): RootStore => useContext(StoreContext);
